/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmergencyAlertPlanDto } from '../../models/emergency-alert-plan-dto';

export interface GetEmergencyAlertPlanData$Params {

/**
 * customer id
 */
  customerId: number;
}

export function getEmergencyAlertPlanData(http: HttpClient, rootUrl: string, params: GetEmergencyAlertPlanData$Params, context?: HttpContext): Observable<StrictHttpResponse<EmergencyAlertPlanDto>> {
  const rb = new RequestBuilder(rootUrl, getEmergencyAlertPlanData.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmergencyAlertPlanDto>;
    })
  );
}

getEmergencyAlertPlanData.PATH = '/customers/{customerId}/emergency-alarm-plan';
